import React, {Component} from 'react';
import {Row, Container, Column} from './layoutComponents';
import {CurrencyInput} from './inputs/currency';
import {UploadButton, FileUploadButton, Paper, MenuBar, HeaderContainer, HeroHeaderImg, HeaderOverlay, HeaderText, MenuText, Form, SubmitButton, InputField, FormLabel, QuoteBlock, Quote, Quotation, MouseText, H5, Span, H4, FormInput, Digit, Avatar, ProgressContainer, ProgressBar} from './styledComponents';



export class Profile extends Component{
  constructor(props){
    super(props);

    this.state={
      displayName: props.user.displayName,
      userName: props.prefs ? props.prefs.userName : 'not set',
      prefs: props.prefs,
      cardnumber: 4242424242424242,
      exp_month: 1,
      exp_year: 2020,
      cvc: 111,
      zip: '00000',
      card: props.card
    }

  }
  componentWillReceiveProps(nextProps){
    console.log("Profile got new props.....")
      if(nextProps.userStatus=="updated"){
        this.setState({
          user: nextProps.user
        })
      }

      this.setState({card:nextProps.card});

      if(nextProps.prefs){
        console.log("Profile got prefs.....")    
          console.log("set the user name.....")
          this.setState({
            prefs: nextProps.prefs,
            userName: nextProps.prefs.userName,
            savingProfile: false,
            displayNameChanged: false,
            userNameChanged: false
          })
        
        

      }
  }
  onChange(evt){
    if(this.props.online){
      this.setState({
        [evt.target.name]:evt.target.value,
        [evt.target.name+"Changed"]: true
      });
    }
  }

  setProfile({displayName, userName}){
    this.props.onProfileChange(displayName, userName);//triggers profile action...t.w.
  }

  setCard({cardnumber,exp_month,exp_year,zip}){
    this.props.onCard({
      card: cardnumber,
      exp_month: exp_month,
      exp_year: exp_year,
      zip: zip
    })
  }
  deleteCard(){
    this.props.onDeleteCard();
  }
  onFocus(evt){
    evt.preventDefault();
    console.log(evt.target.name);
    evt.target.select();
  }
  onFile(evt){
    this.props.onImageUpload(evt.target.files[0])
  }

  onSubmit(evt){
    evt.preventDefault();
    //for better validation, see advanced example

      switch(evt.target.value){
          case "Save":
          this.setState({
            savingProfile: true
          }, this.setProfile(this.state) );

          break;
          case "Donate":
          this.props.onDonate();
          break;
          case "Delete":
          this.deleteCard();
          break;
          case "Try it!":
          this.setState({
            savingCard: true
          }, this.setCard(this.state) );

          break;
          default:
          alert("Error: Please report to admins.")
    }

  }
  disabledInput(evt){

  }
  render(){
    return(
      <div>
        <ProfileForm progress={this.props.progress}
        online={this.props.online}
        fileUploadRequest={this.onFile.bind(this)}
        displayNameChanged={this.state.displayNameChanged}
        savingProfile={this.state.savingProfile}
        onSubmit={this.onSubmit.bind(this)}
        disabledInput={this.disabledInput.bind(this)}
        onChange={this.onChange.bind(this)}
        displayName={this.state.displayName || ''}
        userName={this.state.userName}
        prefs={this.state.prefs}
        card={this.state.card}
        cardnumber={this.state.cardnumber}
        exp_month={this.state.exp_month}
        exp_year={this.state.exp_year}
        cvc={this.state.cvc}
        zip={this.state.zip}
        user={this.props.user}
        cardApproved={this.props.cardApproved}
        chargeNumber={this.props.charges.totalNumber}
        chargeAmount={this.props.charges.totalAmount}
        onFocus={this.onFocus.bind(this)} />
      </div>
    )
  }
}
export const ProfileForm = props =>{
  let upload;
  let avatar;
  let userNameField;
  
  if(!props.prefs){
    userNameField = <label>
      <FormLabel>Username:</FormLabel>
      <InputField onChange={props.onChange} name="userName" type="text" value={props.userName} />
      <MouseText>Checking for username availability...</MouseText>
    </label>;
  }
console.log("Profile form props::");
console.log(props);

  if(props.online){
    upload=<UploadButton>Select</UploadButton>;
  }else{
    upload=<SubmitButton disabled>Select</SubmitButton>
  }

  if(props.user){
    if(props.user.photoURL){
      avatar= props.user.photoURL;
    }
  }
  if(!props.online){
    avatar= "./profile-default.jpg";
  }

  return (
    <Container>
      <HeaderContainer>
      <HeroHeaderImg background="https://firebasestorage.googleapis.com/v0/b/leafletv2.appspot.com/o/theme-assets%2Fleaflet_course_header-03.png?alt=media&token=fe529585-6872-49be-ab07-663cd298e791">
        <HeaderText headerTextColour="white" headerTextWidth="70%">Dont you just hate when the bug is a spelling error?</HeaderText>
      </HeroHeaderImg>
      </HeaderContainer>
      <Row stack middle>
      <Paper paperPadding="0px" paperVertAlign="flex-start" colWidth="40%" colWidthSm="90%" colMaxWidth="400px">
        <MenuBar connected={props.online || false}>
          <MenuText>Your Profile</MenuText>
        </MenuBar>
        <Column space="15px">
          <Container>
          <Form>
            <label>
              <FormLabel>Name:</FormLabel>
              <InputField onChange={props.onChange} name="displayName" type="text" value={props.displayName} />
            </label>
            {!props.savingProfile && userNameField}
            <Row rowAlign="center" middle space="10px" >
            <Column colWidth="30%" colWidthSm="30%">
            <Avatar preview avatarImg={avatar}></Avatar>
            </Column>
            <Row rowWidth="70%" rowJustify="flex-start">
<Column>
            <Row rowAlign="center" rowJustify="space-around">
              <FormLabel>Avatar:</FormLabel>
              <label>
            {upload}

              <FileUploadButton onChange={props.fileUploadRequest} type="file" name="file" accept="image/png, image/jpeg" />
              </label>
</Row>

              {props.progress >= 0 && props.progress< 100 && <Row rowJustify="flex-end"><ProgressContainer>
                <ProgressBar progressWidth={props.progress} />
              </ProgressContainer><div><p>{Math.floor(props.progress)}%</p></div></Row>}
</Column>

            </Row>
            </Row>

            <Row rowJustify="space-around">
              <SubmitButton type="submit" value="Save" onClick={props.onSubmit} disabled={!props.displayNameChanged || props.savingProfile} >Save</SubmitButton>
            </Row>
            {props.savingProfile && <p>Saving...</p>}
            {props.prefs && <a href={`https://oddlylabs.com/${props.prefs.userName}`} rel="external" target="_blank">Git Versioning</a>}
            {props.prefs && <a href={`https://251407325057.signin.aws.amazon.com/console`} rel="external" target="_blank">Cloud 9</a>}
            {props.prefs && <p>login: {props.prefs.userName}</p>}
            {props.prefs && <p>password: {props.prefs.genPasswd}</p>}
          </Form>
          </Container>
        </Column>
      </Paper>

      <Paper paperPadding="0px" paperVertAlign="flex-start" colWidth="40%" colWidthSm="90%" colMaxWidth="400px">
        <MenuBar connected={props.online || false}>
          <MenuText>Your Payments</MenuText>
        </MenuBar>
        <Column space="15px">
        <Container>
      <Form>


          <CreditCard {...props} />
          {props.chargeNumber >0 &&
            <H5>{props.chargeNumber} charges for $ {props.chargeAmount / 100}</H5>
          }


      </Form>
      <MouseText>This form is using a test card. You can use it to try submitting a donation, but cannot change the card and will not be charged.</MouseText>
      </Container>
        </Column>
      </Paper>
      </Row>
      <QuoteBlock><Quote><Quotation className="icon-quote-left"></Quotation>Toto, I have a feeling we're not in WordPress anymore. </Quote></QuoteBlock>
    </Container>
    )
}
export const CreditCard = (props)=>{
console.log(props.online);
  if(props.card && props.cardApproved){
    //user has a card enabled
    return(

      <Column>
      <H4>Card Registered</H4>
      <Span spanPadding="20px 0px">{props.card.brand} ending in: {props.card.lastFour}</Span>
      <Span spanPadding="20px 0px">expires {props.card.exp_month}/{props.card.exp_year}</Span>
      {props.card.brand ?
        <Row rowJustify="space-around" space="20px 0px 20px 0px">
          <SubmitButton disabled={props.online !== true} type="submit" value="Delete" onClick={props.onSubmit} >Delete</SubmitButton>
          <SubmitButton disabled={props.online !== true} type="submit" value="Donate" onClick={props.onSubmit} >Donate</SubmitButton>
        </Row> : <Row><h3>Authorizing....</h3></Row>
      }
      </Column>
    )
  }else{
    //user has not enabled a card yet
    return(
      <div>
        <label>
          <FormLabel>Card:</FormLabel>
          <InputField disabled onChange={props.onChange} name="cardnumber" type="text" value={props.cardnumber} />
        </label>
        <Row rowJustify="space-between">
        <FormInput labelWidth="45%">
          <FormLabel>Month:</FormLabel>
          <InputField disabled onChange={props.onChange} name="exp_month" type="text" value={props.exp_month} />
        </FormInput>
        <FormInput labelWidth="45%">
          <FormLabel>Year:</FormLabel>
          <InputField disabled onChange={props.onChange} name="exp_year" type="text" value={props.exp_year} />
        </FormInput>
        </Row>
        <Row rowJustify="space-between">
        <FormInput labelWidth="45%">
          <FormLabel>CVC:</FormLabel>
          <InputField disabled onChange={props.onChange} name="cvc" type="text" value={props.cvc} />
        </FormInput>
        <FormInput labelWidth="45%">
          <FormLabel>Postal Code:</FormLabel>
          <InputField disabled onChange={props.onChange} name="zip" type="text" value={props.zip} />
        </FormInput>
        </Row>
        <Row rowJustify="space-around" space="20px 0px">
          <SubmitButton disabled={props.online !== true} type="submit" value="Try it!" onClick={props.onSubmit} >Try it!</SubmitButton>

        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/profile.js